import { API_BASE_URL } from "../../store/constans";

export default function MainLoader() {

  const user = JSON.parse(localStorage.getItem("userInfo"));

  return (
    <div className="m-auto h-screen flex flex-col items-center justify-center">
      <img className="object-contain animate-pulse h-[80px] " src={API_BASE_URL + user?.logo} alt="logo" />
      <div className="flex items-center gap-1 text-p-sky">
        <p>Cargando</p>
        <span className="loading loading-dots loading-lg "></span>
      </div>
    </div>
  );
}
